// Single source of truth for how a job is summarized on a card-style row
// (Schedule Board, future surfaces). Exposes headline / subline / chips so a
// caller can render any subset.

const POOL_INSTALL_TYPE_LABELS = {
  install: 'Install',
  liner: 'Liner',
  repair: 'Repair',
  other: 'Other',
}

const SCOPE_CHIPS = [
  { key: 'is_tdi',              label: 'TDI' },
  { key: 'in_place_of_old_pool', label: 'In Place' },
  { key: 'has_deep_end',        label: 'Deep End' },
  { key: 'dirt_haul_away',      label: 'Haul' },
  { key: 'water_delivery',      label: 'Water' },
  { key: 'sand_delivery',       label: 'Sand' },
]

function formatPhone(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '')
  if (digits.length === 10) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6)
  if (digits.length === 11 && digits.startsWith('1')) return '(' + digits.slice(1, 4) + ') ' + digits.slice(4, 7) + '-' + digits.slice(7)
  return raw ? String(raw) : ''
}

function buildHeadline(job) {
  if (job?.business_id !== 'pools') {
    return job?.job_type || job?.title || 'Riverbend Job'
  }
  const size = (job?.pool_size ?? '').trim()
  const typeLabel = POOL_INSTALL_TYPE_LABELS[job?.pool_install_type] || 'Install'
  return (size ? (size + ' ' + typeLabel) : typeLabel).trim()
}

function buildSubline(job) {
  const phone = formatPhone(job?.client_phone)
  const city = (job?.site_city ?? '').trim()
  return [phone, city].filter(Boolean).join(' · ')
}

function buildChips(job) {
  return SCOPE_CHIPS
    .filter((c) => job?.[c.key] === true)
    .map((c) => ({ key: c.key, label: c.label }))
}

export function getJobScopeDisplay(job) {
  return {
    headline: buildHeadline(job),
    subline: buildSubline(job),
    chips: buildChips(job),
  }
}
